import doNothing from '@opsbase/lib-general/utils/doNothing';
import useTemplateUpdate from '@opsbase/react-gql-hooks/template/useTemplateUpdate';
import FormEditor from '@opsbase/web-opform-editor';
import React, { useCallback, useMemo } from 'react';
export function TemplateEditFormTab(props) {
    const { template, mode = 'edit' } = props;
    const updateTemplate = useTemplateUpdate();
    const handleChangeForm = useCallback(async (form) => {
        updateTemplate({
            id: template.id,
            patch: { form },
        }).catch(doNothing);
    }, [template.id, updateTemplate]);
    return useMemo(() => (React.createElement(FormEditor, { mode: mode, id: template.id, title: template.title, canAllQuestionsBeSkipped: template.canAllQuestionsBeSkipped, form: template.form, isScoreEnabled: false, isScorePublic: false, onChangeForm: handleChangeForm })), [
        handleChangeForm,
        mode,
        template.form,
        template.id,
        template.title,
        template.canAllQuestionsBeSkipped,
    ]);
}
export default TemplateEditFormTab;
